<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <ul class="vx-timeline">
      <li v-for="(item, index) in data" :key="index">
          <div class="timeline-icon" :class="`bg-${getColor(item.activity)}`">
              <feather-icon :icon="getIcon(item.activity)" svgClasses="text-white stroke-current w-5 h-5" />
          </div>
          <div class="timeline-info">
              <p class="font-semibold">{{ $t("AuditStatus." + item.activity) }} - v{{ item.version }}</p>
              <span class="activity-desc">{{ item.reason }}</span>
          </div>
          <small class="text-grey activity-e-time">{{ item.user }} - {{ item.time | toLocalDateTime }}</small>
      </li>
  </ul>
</template>

<script>
import StatusEnum from "./StatusEnum"
export default {
  name: 'vx-status',
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  methods: {
    getIcon(activity) {
      switch (activity) {
      case StatusEnum.Submitted:
        return "SendIcon"
      case StatusEnum.Refused:
        return "XIcon"
      case StatusEnum.Approved:
        return "CheckIcon"
      default:
        return "SendIcon"
      }
    },
    getColor(activity) {
      switch (activity) {
      case StatusEnum.Submitted:
        return "primary"
      case StatusEnum.Refused:
        return "danger"
      case StatusEnum.Approved:
        return "success"
      default:
        return "primary"
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
